import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
      <img src="/brand/logos/voluntoldhq-monogram-on-light.svg" alt="" className="h-20 w-auto mx-auto mb-4" />
      <span className="kicker">404</span>
      <h1 className="mt-2 font-head font-semibold uppercase text-4xl text-[#1E1E1E]">Off the field</h1>
      <p className="mt-3 text-[#6E6E6E]">That page ran the wrong route. Let's get you back in the game.</p>
      <div className="mt-6 flex flex-wrap gap-3 justify-center">
        <Link to="/" className="bg-[#2D2D2D] text-[#F3F1EC] font-head uppercase tracking-wide text-sm px-6 py-3 hover:bg-[#242424] transition-colors">Back home</Link>
        <Link to="/assessment" className="border-2 border-[#2D2D2D] text-[#2D2D2D] font-head uppercase tracking-wide text-sm px-6 py-3 hover:bg-[#2D2D2D] hover:text-[#F3F1EC] transition-colors">Where do I stand?</Link>
      </div>
    </div>
  );
}
